export function InfoCircleFilled({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      className={className}
    >
      <path
        d="M9 0C11.3869 0 13.6764 0.947915 15.3643 2.63574C17.0521 4.32357 18 6.61305 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9C0 4.02944 4.02944 0 9 0ZM7.875 7.125C7.46079 7.125 7.125 7.46079 7.125 7.875C7.125 8.28921 7.46079 8.625 7.875 8.625H8.4375C8.54105 8.625 8.625 8.70895 8.625 8.8125V12.1875C8.625 12.2911 8.54105 12.375 8.4375 12.375H7.875C7.46079 12.375 7.125 12.7108 7.125 13.125C7.125 13.5392 7.46079 13.875 7.875 13.875H10.875C11.2892 13.875 11.625 13.5392 11.625 13.125C11.625 12.7108 11.2892 12.375 10.875 12.375H10.3125C10.2089 12.375 10.125 12.2911 10.125 12.1875V8.625C10.125 7.79657 9.45343 7.125 8.625 7.125H7.875ZM9.1875 3.75C8.56618 3.75 8.0625 4.25368 8.0625 4.875C8.0625 5.49632 8.56618 6 9.1875 6C9.80882 6 10.3125 5.49632 10.3125 4.875C10.3125 4.25368 9.80882 3.75 9.1875 3.75Z"
        fill="currentColor"
      />
    </svg>
  );
}
